/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function HeartPulseFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="heart-pulse-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M15.472 4.452C17.09 4.14 19.009 4.623 20.415 5.81C21.612 6.923 22.33 8.538 22.358 10.031C22.386 11.523 21.729 13.165 20.575 14.322L12.519 22.042C12.374 22.181 12.187 22.25 12 22.25C11.813 22.25 11.626 22.181 11.481 22.042L4.371 15.228L6.994 15.25C7.303 15.253 7.582 15.065 7.696 14.779L9.024 11.46L11.311 16.795C11.426 17.064 11.686 17.241 11.978 17.25C12.27 17.258 12.54 17.097 12.671 16.835L14.464 13.25L16 13.25C16.414 13.25 16.75 12.914 16.75 12.5C16.75 12.086 16.414 11.75 16 11.75L14 11.75C13.716 11.75 13.456 11.911 13.329 12.165L12.052 14.718L9.689 9.205C9.57 8.926 9.294 8.746 8.991 8.75C8.688 8.754 8.416 8.94 8.304 9.221L6.494 13.746L2.898 13.716C2.074 12.63 1.619 11.278 1.642 10.031C1.67 8.538 2.388 6.923 3.585 5.81C4.991 4.623 6.91 4.14 8.528 4.452C9.816 4.7 11.096 5.487 12 6.618C12.904 5.487 14.184 4.7 15.472 4.452Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
    </svg>
  )
}
